import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MdbSidenavComponent } from 'mdb-angular-ui-kit/sidenav';
import { DateUtility, NightwebUtil } from '../../../utils';
import { ENDUSER } from '../../../constants';

@Component({
    selector: 'app-end-user-profile-information',
    templateUrl: './end-user-profile-information.component.html',
    styleUrls: ['./end-user-profile-information.component.css'],
    standalone: false
})
export class EndUserProfileInformationComponent implements OnInit {

  @Input() data !: any;
  @ViewChild('sidenav', { static: false }) public sidenav!: MdbSidenavComponent;
  enduserName: string = '';
  enduserDOB: string = '';
  perpetratorDOB: string = '';
  isLoggedInEndUser: boolean = this.nightwebUtil.isEndUser();

  constructor(
    public dateUtil: DateUtility,
    private nightwebUtil: NightwebUtil,
  ) {}

  ngOnInit(): void {}

  onOpenSidenav() {
    this.enduserName = this.nightwebUtil.getDisplayName(this.data.demographic);
    this.enduserDOB = this.dateUtil.convertToMMddYYYY(this.data.demographic.dob);
    if(this.data?.info?.perpetratorDob) {
      this.perpetratorDOB = this.dateUtil.convertToMMddYYYY(this.data.info.perpetratorDob);
    }
    this.sidenav.toggle();
  }

  onClose() {
    this.sidenav.toggle();
  }

  getLanguageDisplayName(languageCode: string): string {
    if (!languageCode) return '';
    const language = ENDUSER.LANGUAGE_LIST.find(lang => lang.value === languageCode);
    return language ? language.name : languageCode;
  }
}
